import Vue from 'vue';
import ClickOutside from 'vue-click-outside';

Vue.component('video-item', {
    directives: {
        ClickOutside
    },

    props: {
        videoUrl: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            showOverlay: false
        };
    },

    computed: {
        player() {
            return this.$refs.youtube.player;
        }
    },

    watch: {
        showOverlay: function() {
            if (this.showOverlay) {
                document.documentElement.style.overflowY = 'hidden';
                this.playVideo();
            } else {
                document.documentElement.style.overflowY = 'scroll';
                this.pauseVideo();
            }
        }
    },

    mounted() {
        this.$el
            .querySelector('.card-video__overlay')
            .addEventListener('click', () => {
                this.showOverlay = false;
            });
    },

    methods: {
        playVideo() {
            this.player.playVideo();
        },

        pauseVideo() {
            this.player.pauseVideo();
        },

        getVideoId() {
            return this.$youtube.getIdFromUrl(this.videoUrl);
        }
    }
});
